import FAApi from './_faVoucherListApi';
import httpClient from '@/apis/base/httpclient';

class FAVoucherCustomApi extends FAApi {
  constructor() {
    super();
  }
  controllerName = 'favouchercustoms';
}

export default new FAVoucherCustomApi();
